import React from 'react';
import type { CardCompare, CardMetric } from '@ctd/agent-contract';
import { describeDelta } from '../utils/card-delta';
import type { DeltaTone } from '../utils/card-delta';
import style from '../style.module.scss';

const toneClass = (tone: DeltaTone): string =>
    tone === 'good'
        ? style.delta_good
        : tone === 'bad'
        ? style.delta_bad
        : style.delta_neutral;

/** A change between two values: the relative one when the data has it, then the absolute one. */
export const DeltaChip: React.FC<{
    metric: Pick<CardMetric, 'unit' | 'lowerIsBetter'>;
    compare: CardCompare;
}> = ({ metric, compare }) => {
    const { tone, relative, absolute } = describeDelta(metric, compare);
    return (
        <span className={`${style.delta} ${toneClass(tone)}`} data-tone={tone}>
            {relative ? (
                <>
                    <span>{relative}</span>{' '}
                    <span className={style.delta_abs}>({absolute})</span>
                </>
            ) : (
                <span>{absolute}</span>
            )}
        </span>
    );
};
